/**
 * `entities/project-member` TanStack Query key factory.
 *
 * Tuple shapes are INLINED to match the historical `PROJECTS_QUERY_KEYS.members.*`
 * + `PROJECTS_QUERY_KEYS.workspaceUsers.*` factories in
 * `entities/project/api/query-keys.ts` byte-for-byte.
 *
 */

export const PROJECT_MEMBER_QUERY_KEYS = {
  /** Constant tuple for invalidating EVERY project-members cache. */
  all: ['project-members'] as const,

  /** Members of a specific platform project under a specific workspace. */
  byProject: (workspaceId: string, platformProjectId: string) =>
    ['project-members', workspaceId, platformProjectId] as const,

  /**
   * Workspace-level user search. The optional `name` slot is preserved as
   * `undefined` rather than omitted so partial-match invalidation via
   * `.slice(0, N)` behaves predictably.
   */
  workspaceUsers: {
    all: ['workspace-users'] as const,
    search: (workspaceId: string, name?: string) => ['workspace-users', workspaceId, name] as const,
  },

  /** The roles a project's members panel offers; whether each is assignable depends on the project. */
  assignableRoles: (platformProjectId: string) =>
    ['project-assignable-roles', platformProjectId] as const,

  /** Role assignments for a specific project. */
  roleAssignments: (platformProjectId: string) =>
    ['project-role-assignments', platformProjectId] as const,
} as const;
